module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "dedf"
  }, [_vm._v("For my parents, William Diderichsen Webber")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("and Marilynn Carlson Webber,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("who taught me that books can make real")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("a time and place gone by.")]), _vm._v(" "), _c('p', {
    staticClass: "dedf"
  }, [_vm._v("For those of Hawaiian heritage")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("who proudly preserve their culture.")]), _vm._v(" "), _c('p', {
    staticClass: "dedf"
  }, [_vm._v("For all who love Ka‘iulani’s beautiful islands")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("and seek to live in the true spirit of aloha.")]), _vm._v(" "), _c('p', {
    staticClass: "dedf"
  }, [_vm._v("And for my princess, Linnéa Juliet Scott.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10bfa202","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-kaiulani-0006.vue
// module id = 69
// module chunks = 0